import { PriceTypeEnum, UnitPrice } from '@boels/models';

export function getPricingDetails(unitPrices: UnitPrice[]): {
  price: string;
  currency: string;
  pricing_unit: number;
} {
  let selectedUnitPrice: UnitPrice | undefined;

  // Always use WEEK as the unit price if it exists
  selectedUnitPrice = unitPrices.find(
    (price) => price.unit === PriceTypeEnum.WEEK,
  );

  // If WEEK unit price does not exist, use the first available unit price
  if (!selectedUnitPrice) {
    selectedUnitPrice = unitPrices[0];
  }

  // Set the pricing unit based on the unit price
  // Set the pricing unit based on the unit price
  const pricing_unit =
    selectedUnitPrice?.unit === PriceTypeEnum.DAY
      ? 1
      : selectedUnitPrice?.unit === PriceTypeEnum.WEEK
        ? 7
        : selectedUnitPrice?.unit === PriceTypeEnum.DAYPLUS
          ? 5
          : 0;

  return {
    price: selectedUnitPrice?.sdFormattedValue || '',
    currency: selectedUnitPrice?.currencyIso || '',
    pricing_unit: pricing_unit,
  };
}
